export enum CollegeProgramStatus {
	Student = 'student',
	Alumnus = 'alumnus',
}